// extracted by mini-css-extract-plugin
module.exports = {"root":"QuoteHardwareItems_root__2BbmH"};